import { motion } from "motion/react";

export default function ProgressBar({
  current,
  total,
}: {
  current: number;
  total: number;
}) {
  const pct = Math.round((current / total) * 100);
  return (
    <div className="w-full max-w-xl mx-auto mb-8">
      <div className="flex items-center justify-between mb-2">
        <span
          className="text-[12px] text-slate-500"
          style={{ fontWeight: 500 }}
        >
          Question {current} of {total}
        </span>
        <span
          className="text-[12px] text-violet-600"
          style={{ fontWeight: 700 }}
        >
          {pct}% complete
        </span>
      </div>
      <div className="w-full bg-slate-100 rounded-full h-2">
        <motion.div
          animate={{ width: `${pct}%` }}
          transition={{ duration: 0.4 }}
          className="h-2 rounded-full bg-gradient-to-r from-violet-600 to-purple-500"
        />
      </div>
    </div>
  );
}
